import {
  DataPoint,
  SkillsRadarChartDataPoint,
  SkillsRadarChartSeries,
} from './skills-radar.types'

export const getArcWidth = (dataLength: number) => {
  return 360 / dataLength
}

export const getData = (
  series: SkillsRadarChartSeries,
  externalMaxLevel?: number
) => {
  const categoryCount: Record<string, number> = {}
  const map: Map<string, DataPoint> = new Map()
  const seriesNames = Object.keys(series)

  let maxLevel = externalMaxLevel ?? 0

  Object.entries(series).forEach(([seriesName, set]) => {
    set.skills.forEach((skill) => {
      let existing = map.get(skill.id)

      if (!existing) {
        existing = createDefaultDataPoint(seriesNames, skill)
        categoryCount[skill.category] ||= 0
        categoryCount[skill.category]++
      }

      map.set(skill.id, { ...existing, [seriesName]: skill.level })

      maxLevel = Math.max(maxLevel, skill.level)
    })
  })

  const data = Array.from(map.values()).sort((a, b) => {
    if (a.category === b.category) {
      return a.label.localeCompare(b.label)
    } else {
      return a.category.localeCompare(b.category)
    }
  })

  return { categoryCount, data, maxLevel }
}

export const getPolarAngles = (
  arcWidth: number,
  categoryCount: Record<string, number>
) => {
  return Object.keys(categoryCount)
    .sort((a, b) => a.localeCompare(b))
    .reduce(
      (arr, key, i, original) => {
        if (i === original.length - 1) return arr

        const previousTotal = arr[i]
        const currentCategoryWidth = categoryCount[key] * arcWidth

        return [...arr, previousTotal - currentCategoryWidth]
      },
      [arcWidth / 2] as number[]
    )
}

const createDefaultDataPoint = (
  seriesNames: string[],
  skill: SkillsRadarChartDataPoint
) => {
  const dataPoint: DataPoint = {
    category: skill.category,
    label: skill.name,
  }

  return seriesNames.reduce(
    (point, seriesName) => ({ ...point, [seriesName]: 0 }),
    dataPoint
  )
}
